import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import moment from 'moment';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
export default (function ($prop, ctx) {
  var code = ctx.$f7route.params.code;
  var totalAmount = 0,
      totalOrders = 0;
  ctx.$on('popup:open', function () {
    var currentPopup = Base.app.popup.create({
      el: '.customer-search-popup'
    });
    var $list = currentPopup.$el.find('.order-list');

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var loader, rs, detail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loader = Base.app.dialog.preloader('Đợi chút nhé...! ;)');
              _context.next = 3;
              return Base.api('Customer', 'history', {
                code: code
              });

            case 3:
              rs = _context.sent;
              loader.close();

              if (!(rs.status !== 'success' || rs.rows.length === 0)) {
                _context.next = 9;
                break;
              }

              Base.app.dialog.alert('Không có dữ liệu lịch sử cho khách này.');
              ctx.$update();
              return _context.abrupt("return", false);

            case 9:
              detail = function detail(item) {
                return item.invoiceDetails.map(function (itemDetail) {
                  return "\n            <div class=\"product-item\">".concat(itemDetail.productCode, " - ").concat(itemDetail.productName, " x").concat(itemDetail.quantity, "</div>\n            <div class=\"product-price\">").concat(Utils.num2Str(itemDetail.subTotal), "</div>\n          ");
                }).join('');
              };

              totalOrders = rs.rows.length;
              rs.rows.forEach(function (item) {
                totalAmount += item.statusValue === 'Hoàn thành' ? parseInt(item.total) : 0;
                $list.append($("<div class=\"order-item block\">\n            <div class=\"order-id\"><i class=\"f7-icons icon text-color-orange\" style=\"font-size: 14px;\">arrowtriangle_right_fill</i> ".concat(item.code, " - ").concat(item.branchName, " (").concat(item.statusValue, ")</div>\n            <div class=\"order-date\"><i class=\"f7-icons icon text-color-orange\" style=\"font-size: 14px;\">calendar</i> ").concat(moment(item.createdDate).format(Base.dateTimeFormat), "</div>\n            <div class=\"order-items\">\n              ").concat(detail(item), "\n            </div>\n            <div class=\"total\">\n              <i class=\"f7-icons icon text-color-orange\" style=\"font-size: 14px;\">money_dollar</i> ").concat(Utils.num2Str(item.total), "\n            </div>\n          </div>")));
              });
              ctx.$update();

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup customer-search-popup">
    <div class="view">
      <div class="page">
        <div class="navbar">
          <div class="navbar-bg"></div>
          <div class="navbar-inner">
            <div class="title">Lịch sử mua hàng</div>
            <div class="right">
              <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
            </div>
          </div>
        </div>
        <div class="page-content">

          <div class="block">
            <h4 class="row">
              <div class="col">Tổng số hoá đơn</div>
              <div class="col">${totalOrders}</div>
            </h4>
            <h4 class="row">
              <div class="col">Tổng tiền</div>
              <div class="col">${Utils.num2Str(totalAmount)}</div>
            </h4>
          </div>

          <div class="order-list">
            
            

          </div>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});